import React from 'react';
import PropTypes from 'prop-types';
import AiFeatures from './ai/AiFeatures';
import { Ic } from '../shell/Icons';

// Bottom action bar — matches the agreed mockup `.actionbar` (Save primary,
// the rest secondary/ghost) while keeping every action + the test ids.
const ItemDetailsToolbar = ({
  hasChanges,
  loading,
  handleSave,
  handleCancel,
  handleDelete,
  handleLink,
  handleOpenAddDialog,
  aiFeatures,
  calculations,
}) => {
  return (
    <div className="actionbar actionbar-sticky">
      <button type="button"
        className="btn primary"
        onClick={handleSave}
        disabled={!hasChanges || loading}
        data-testid="item-save"
      >
        <Ic name="check" />{loading ? 'Saving…' : 'Save'}
      </button>
      <button type="button"
        className="btn secondary"
        onClick={handleCancel}
        disabled={!hasChanges || loading}
        data-testid="item-cancel"
      >
        Cancel
      </button>
      <button type="button" className="btn secondary" onClick={handleDelete} disabled={loading} data-testid="item-delete" aria-label="Delete this item">
        Delete
      </button>
      <button type="button" className="btn secondary" onClick={handleLink} data-testid="item-link" aria-label="Link this item to another">
        <Ic name="link" />Link
      </button>

      {/* AI tools dropdown (keeps its own menu/behaviour) */}
      <AiFeatures {...aiFeatures} onCalculateLimitsClick={calculations?.handleCalculateLimits} />

      <button type="button" className="btn secondary" onClick={() => handleOpenAddDialog(false)} data-testid="item-new-requirement" aria-label="Create a new requirement">
        <Ic name="plus" />New Requirement
      </button>
      <button type="button" className="btn secondary" onClick={() => handleOpenAddDialog(true)} data-testid="item-new-container" aria-label="Create a new container">
        <Ic name="folder" />New Container
      </button>
    </div>
  );
};

ItemDetailsToolbar.propTypes = {
  hasChanges: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleLink: PropTypes.func.isRequired,
  handleOpenAddDialog: PropTypes.func.isRequired,
  aiFeatures: PropTypes.object.isRequired,
  calculations: PropTypes.object,
};

export default ItemDetailsToolbar;
